import React, {useContext, useEffect, useState} from "react"
import styled from "styled-components";
import { BE_ADDR } from "../../../api/host";

import TranslationContext from "../../../context/TranslationContext";
import BuilderContext from "../../../context/BuilderContext"
import UserContext from "../../../context/UserContext"

const FooterLinkLabel = styled.label`
  &:after {
    ${props => props.checked === true && ({
      width: "2px",
      height: "2px",
    })}
  }
`

const FooterLogo = styled.img`
  width: ${props => props.logo_2_width};
`


const Footer = ({reviewMode = true}) => {
    const {acceptRules, setAcceptRules}  = useContext(UserContext)
    const [labelChecked, setLabelChecked] = useState(acceptRules)
    const {getTranslation, language} = useContext(TranslationContext)
    const { style } = useContext(BuilderContext)
    const [link, setLink] = useState("")

    const toogleRulesCheckbox = () => {
      setAcceptRules(!acceptRules)
    }

    const linkOffert = () => {
      const offertLangTranslation = ["ru", "en", "es", "de", "zh", "ar", "fr"]
      if (offertLangTranslation.includes(language)) {
        return `/assets/static/offerta/${language}/Offert.pdf`
      }
      return `/assets/static/offerta/en/Offert.pdf`
    }
    
    const linkOffertV2 = () => {
      const offertLangTranslation = ["ru", "en"]
      if (offertLangTranslation.includes(language)) {
        return `./${language}.pdf`
      }
      return `./ru.pdf` 
    }

    useEffect(() => {
        document.getElementById("footer_link").innerHTML = ""
        document.getElementById("footer_link").insertAdjacentHTML('afterbegin', getTranslation("info_offert"))
        setLink(linkOffertV2())
    }, [getTranslation])

    return <div id="footer" className="mb-1">
        {
            style.ch_box_rules && <FooterLinkLabel
                className = 'lbl-checkbox-rules'
                checked={acceptRules}
                onClick={toogleRulesCheckbox}
            />
        }
        <a
            className='footer-link'
            id="footer_link"
            {...(reviewMode && {href: link})}
        />
        {
          style.logo_2_path !== "" && <div>
            <img
                className='logo-bot-center'
                src={`${BE_ADDR}${style.logo_2_path}`}
                width={style.logo_2_width}
            />
        </div>
        }
    </div>
}

export default Footer